<template>
  <div class="absolute top-1/2 -mt-12 left-0 w-full" v-if="order_history.length == 0">
    <div class="text-center w-full">
      <null-icon></null-icon>
    </div>
    <div class="pt-5 font-extrabold text-center text-xl">There are no past deliveries</div>
    <div class="pt-2 text-center text-lg leading-none px-6">
      You don’t have any delivered, cancelled or rejected orders at this point
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NullIcon from '../icons/NullIcon.vue'
export default {
  components: { NullIcon },
  computed: {
    ...mapState('history', ['order_history'])
  },
  mounted() {
    this.$store.dispatch('history/orderHistory')
  }
}
</script>

<style></style>
